import React from 'react';
import { Link } from 'react-scroll';
import { FaUsers, FaRuler, FaStar } from 'react-icons/fa';
import './Spaces.css';
import IconWrapper from './IconWrapper';

const Spaces: React.FC = () => {
  const spaces = [
    {
      id: 5,
      title: 'Membership',
      image: require('../assets/images/spaces/membership.jpg'),
      description: 'Flexible coworking membership with access to shared workspace and community amenities.',
      capacity: 'Flexible',
      featured: false
    },
    {
      id: 6,
      title: 'Drop In Day Use',
      image: require('../assets/images/spaces/drop_in_day_use.jpg'),
      description: 'Flexible workspace access for a single day with all amenities included.',
      capacity: '1 Person',
      featured: false
    },
    {
      id: 4,
      title: 'Meeting Rooms',
      image: require('../assets/images/spaces/meeting_rooms.jpg'),
      description: 'Professional meeting spaces equipped with modern technology and amenities for your important discussions.',
      capacity: '2-10 People',
      featured: false
    },
    {
      id: 1,
      title: 'Dedicated Desks',
      image: require('../assets/images/spaces/dedicated_desks.jpg'),
      description: 'Reserved desk in our open coworking area with 24/7 access and all amenities included.',
      capacity: '1 Person',
      featured: false
    },
    {
      id: 2,
      title: 'Private Internal Offices',
      image: require('../assets/images/spaces/private_internal_office.JPG'),
      description: 'Fully furnished private office with all utilities included and flexible lease terms.',
      capacity: '1-3 People',
      featured: true
    },
    {
      id: 3,
      title: 'Private Window Offices',
      image: require('../assets/images/spaces/window_office.JPG'),
      description: 'Premium private office with natural light, views, and all the amenities you need to succeed.',
      capacity: '2-6 People',
      featured: false
    }
  ];

  return (
    <section id="spaces" className="spaces">
      <div className="container">
        <div className="section-header">
          <h2>Workspace Solutions That Fit Your Needs</h2>
          <p>Choose the perfect workspace solution for your business needs</p>
        </div>

        <div className="spaces-grid">
          {spaces.map((space) => (
            <div key={space.id} className={`space-card ${space.featured ? 'featured' : ''}`}>
              {space.featured && (
                <div className="featured-tag">
                  <IconWrapper icon={FaStar} /> Popular
                </div>
              )}
              <div className="space-image">
                <img src={space.image} alt={space.title} />
              </div>
              <div className="space-content">
                <h3>{space.title}</h3>
                <p>{space.description}</p>
                <div className="space-details">
                  <div className="space-capacity">
                    <IconWrapper icon={FaUsers} />
                    <span>{space.capacity}</span>
                  </div>
                </div>
                <Link to="contact" smooth={true} duration={500} className="space-cta book-now">
                  Book Now
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="virtual-tour-section">
          <div className="section-header">
            <h2>Take a Virtual Tour</h2>
            <p>Explore our spaces in 3D before your visit</p>
          </div>
          <div className="virtual-tour-container">
            <div style={{ display: 'block', position: 'relative', paddingBottom: '57%', height: 0, overflow: 'hidden' }}>
              <iframe
                src="https://my.matterport.com/show/?m=tN5UdFMDNbK"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                allowFullScreen
                title="Virtual Office Tour"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Spaces; 